// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"605d9256","453":"f6c94965","455":"d215164c","503":"28758f43","602":"83b53d97","695":"ac05abec","926":"55e85fd0","977":"82141ca8","999":"aa73bb28"}[chunkId] + ".chunk.js";
};